export default {
  confirm: "تایید",
  adjustAgain: "تنظیم مجدد"
};
